module.exports = __webpack_public_path__ + "img/logo.d0566f1b.png";